import React from 'react';
import './Mobile.css';
import PCIcon from './assets/pc-icon.png';
import QRIcon from './assets/qr-icon.png';
import NavIcon from './assets/nav-icon.png';
import {filterApps} from './utils';

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pcConfig: [],
            qrConfig: [],
            activeNav: 0,

            showIOSHelperModal: false,

            openNav: false,
            floatNav: false,
        }
    }

    filterApp = (list, source) => {
        list.map(item => {
            if (item.is_dir) {
                this.filterApp(item.children, source)
            } else {
                source.push(item);
            }
        })
    }

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.resetScale();
        });
        this.resetScale();

        this.loadPCConfig((text) => {
            let config = JSON.parse(text);
            let outsideApps = filterApps(config.filter(item => !item.is_dir))
            let pcApps = config.filter(item => item.is_dir);
            pcApps.map((app, i) => {
                if (app.is_dir) {
                    let arr = [];
                    this.filterApp(pcApps[i].children, arr);
                    pcApps[i].children = arr;
                }
            })

            this.setState({
                pcConfig: [{name: '常用软件下载', hiddenCard: true, is_dir: true}, {name: '公众号', hiddenCard: true, is_dir: true}, {name: '办公软件下载', is_dir: true, children: outsideApps}, ...pcApps]
            })
        });
        this.loadQRConfig((text) => {
            let config = JSON.parse(text);
            this.setState({
                qrConfig: config
            })
        });

        window.onscroll = () => {
            // let scrollTop = document.documentElement.scrollTop;
            // if (scrollTop > 87) {
            //     this.setState({
            //         floatNav: true
            //     });
            // } else {
            //     this.setState({
            //         floatNav: false
            //     });
            // }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize');
    }

    resetScale = () => {
        let w = window.outerWidth;
        var viewport = document.querySelector("meta[name=viewport]");
        let scale = w / 750;
        viewport.setAttribute('content', `width=device-width, initial-scale=${scale}, maximum-scale=${scale}`);
    }

    loadPCConfig(cb) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/config.json');
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {  //200 表示相应成功 304 表示缓存中存在请求的资源
                    // 对响应的信息写在回调函数里面
                    var str = xhr.status + ' ' + xhr.responseText;
                    cb(xhr.responseText);
                }
                else {
                    return 'request is unsucessful ' + xhr.status;
                }
            }
        };
        xhr.send();
    }

    loadQRConfig(cb) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/qr-config.json');
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {  //200 表示相应成功 304 表示缓存中存在请求的资源
                    // 对响应的信息写在回调函数里面
                    var str = xhr.status + ' ' + xhr.responseText;
                    cb(xhr.responseText);
                }
                else {
                    return 'request is unsucessful ' + xhr.status;
                }
            }
        };
        xhr.send();
    }

    selectPcNAV = (i) => {
        this.setState({
            activeNav: i
        })
    }

    toggleShowIOSHelperModal = () => {
        this.setState({
            showIOSHelperModal: !this.state.showIOSHelperModal
        })
    }

    toggleOpenNav = () => {
        this.setState({
            openNav: !this.state.openNav
        })
    }

    closeNav = () => {
        this.setState({
            openNav: false
        })
    }


    commonSoftwareDownload = () => {
        const {qrConfig=[]} = this.state;
            return (
                <div className="card commonly">
                    <div id='常用软件下载' className="card-title">常用软件下载</div>
                    <div onClick={this.toggleShowIOSHelperModal} className="ios-question">
                        <a><span>?</span>苹果手机下载常见问题</a>
                    </div>
                    <div className="qr-title">
                        <div>名称</div>
                        <div>适用人群</div>
                        <div>操作</div>
                    </div>
                    <div className="qr-common-download">
                        {
                            qrConfig.map(item => {
                                return (
                                    <div key={item.qr} className="qr-common-item">
                                        <div className="qr-common-item-name qr-common-item-common">
                                            {
                                                item.type ? <span>{item.name}</span> : <a href={item.url}>{item.name}</a>
                                            } 
                                        </div>
                                        <div className="qr-common-item-name">{item.usedCrowd}</div>
                                        <div className="qr-common-item-name qr-common-item-common">
                                            <a href={item.qr}>查看二维码</a>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )
    }

    render() {
        const {pcConfig, activeNav, qrConfig, showIOSHelperModal, openNav, floatNav} = this.state;
        let dirs = pcConfig.filter(item => item.is_dir);
        let origin = window.location.origin;
        return (<div id="container" className="mobile-container">
            <nav className={floatNav && "float-nav"}>
                <div className="navSlogan">
                    <img width={50} height={50} src={NavIcon} />
                    <span>中天系统软件下载目录</span>
                </div>
            </nav>
            <div className={"mobileNavWrapper " + (floatNav && "float-nav")}>
                <ul className={openNav ? "mobileNav open" : "mobileNav"}>
                    {dirs.map((item, i) => <li  key={item.name} onClick={this.closeNav} className={i == activeNav && 'active'}>
                        <a href={'#' + item.name}>{item.name}</a>
                    </li>)}
                </ul>
                <div onClick={this.toggleOpenNav} className={"mobileNavMore"}>
                    <svg className="more-btn" width="22px" height="12px" viewBox="0 0 22 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <title>icon_jt_gray_24</title>
                        <desc>Created with Sketch.</desc>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="画板" transform="translate(-709.000000, -157.000000)">
                                <g id="编组-45" transform="translate(690.000000, 128.000000)">
                                    <g id="编组-2">
                                        <g id="icon_jt_gray_24" transform="translate(30.000000, 34.500000) rotate(90.000000) translate(-30.000000, -34.500000) translate(19.500000, 24.000000)">
                                            <g id="Group-8" transform="translate(0.000000, 0.000000)">
                                                <g id="编组-10" transform="translate(0.829365, 0.567460)">
                                                    <rect id="矩形" x="5.68434189e-14" y="-4.97379915e-14" width="20" height="20"></rect>
                                                    <polyline id="Path-4" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill-rule="nonzero" points="5.63492063 0.51402781 14.3650794 10.1172263 5.63492063 19.4859722"></polyline>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>

            <div id="mobile-content">
                {/* <div className="card commonly">
                    <div id='常用软件下载' className="card-title">常用软件下载</div>
                    <div onClick={this.toggleShowIOSHelperModal} className="ios-question">
                        <a><span>?</span>苹果手机下载常见问题</a>
                    </div>
                    <ul className="app-download">
                        {qrConfig.filter(item=>!item.type).map(item=><li>
                            <img width={100} height={100} src={item.qr} />
                            <div className="app-name">{item.name}</div>
                            <a className="app-down-btn" href={item.url}>下载</a>
                        </li>)}
                    </ul>
                </div> */}
                {/* <div className="card mp">
                    <div id='公众号' className="card-title">公众号</div>
                    <ul className="app-download">
                        {qrConfig.filter(item=>(item.type)).map(item=><li>
                            <img width={180} height={180} src={item.qr} />
                            <div className="app-name">{item.name}</div>
                        </li>)}
                    </ul>
                </div> */}
                {
                    this.commonSoftwareDownload()
                }
                <div>
                    {dirs.filter(item => !item.hiddenCard).map(dir => <div className={'card'}  key={dir.name}>
                        <div className="card-title" id={dir.name}>{dir.name}</div>
                        <ul className={'program-list'}>
                            {dir.children.filter(item => !item.is_dir).map(file => <li  key={file.path}>
                                <div>
                                    <div>{file.name}</div>
                                    <div className="dirFileItemDesc"><span>{change(file.size)}</span> <span>{dateFormat(file.updated_at, 'yyyy-MM-dd')}更新</span></div>
                                </div>
                                <a href={`${origin}${file.path}`} className={'app-down-btn'}>下载</a>
                            </li>)}
                        </ul>
                    </div>)}
                </div>
            </div>

            {showIOSHelperModal && <div onClick={this.toggleShowIOSHelperModal} className="modal-mask">
                <div onClick={e => e.stopPropagation()} className="modal">
                    <div className="modal-close">
                        <svg onClick={this.toggleShowIOSHelperModal} t="1587970689457" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5500" width="200" height="200"><path d="M512 192c-176.7 0-320 143.3-320 320s143.3 320 320 320 320-143.3 320-320-143.3-320-320-320z m176.8 459.9c9.8 9.8 9.8 25.9 0 35.7l-0.5 0.5c-9.8 9.8-25.9 9.8-35.7 0L516.2 551.6 379.7 688.1c-9.8 9.8-25.9 9.8-35.7 0l-0.5-0.5c-9.8-9.8-9.8-25.9 0-35.7L480 515.4 343.5 379c-9.8-9.8-9.8-25.9 0-35.7l0.5-0.5c9.8-9.8 25.9-9.8 35.7 0l136.4 136.4 136.4-136.4c9.8-9.8 25.9-9.8 35.7 0l0.5 0.5c9.8 9.8 9.8 25.9 0 35.7L552.3 515.4l136.5 136.5z" fill="#cdcdcd" p-id="5501"></path></svg>
                    </div>
                    <img src="http://t.zto.cn/reminder.jpeg" width={250} />
                    <div onClick={this.toggleShowIOSHelperModal} className="modal-know-btn">我知道了</div>
                </div>
            </div>}
        </div>);
    }

    renderPCIcon = () => {
        return <svg width="42px" height="39px" viewBox="0 0 42 39" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1="50%" y1="0.379466195%" x2="50%" y2="100%" id="linearGradient-1">
                    <stop stop-color="#417BD7" offset="0.0633445946%"></stop>
                    <stop stop-color="#82ABEF" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50%" y1="0.316321973%" x2="50%" y2="100%" id="linearGradient-2">
                    <stop stop-color="#417BD7" offset="0.0633445946%"></stop>
                    <stop stop-color="#82ABEF" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50%" y1="1.78038016%" x2="50%" y2="100%" id="linearGradient-3">
                    <stop stop-color="#FFFFFF" offset="0%"></stop>
                    <stop stop-color="#DEEAFF" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50%" y1="0.379466195%" x2="50%" y2="100%" id="linearGradient-4">
                    <stop stop-color="#417BD7" offset="0.0633445946%"></stop>
                    <stop stop-color="#82ABEF" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="0%" y1="66.6452855%" x2="100%" y2="33.3547145%" id="linearGradient-5">
                    <stop stop-color="#A3BFE1" offset="0%"></stop>
                    <stop stop-color="#477FEE" offset="44.0904723%"></stop>
                    <stop stop-color="#77A2F0" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="0.129533505%" y1="0.442570418%" x2="104.553571%" y2="0.442570418%" id="linearGradient-6">
                    <stop stop-color="#417BD7" offset="0.0633445946%"></stop>
                    <stop stop-color="#82ABEF" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="99.3998488%" y1="34.9626262%" x2="0%" y2="65.2297695%" id="linearGradient-7">
                    <stop stop-color="#4D83EE" offset="0.0633445946%"></stop>
                    <stop stop-color="#BED7FF" offset="69.9203779%"></stop>
                    <stop stop-color="#4D83EE" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50%" y1="0.379466195%" x2="50%" y2="100%" id="linearGradient-8">
                    <stop stop-color="#417BD7" offset="0.0633445946%"></stop>
                    <stop stop-color="#82ABEF" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50%" y1="0.379466195%" x2="50%" y2="100%" id="linearGradient-9">
                    <stop stop-color="#417BD7" offset="0.0633445946%"></stop>
                    <stop stop-color="#82ABEF" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Artboard备份-2" transform="translate(-40.000000, -113.000000)">
                    <g id="编组-50" transform="translate(24.000000, 94.000000)">
                        <g id="编组-46" transform="translate(10.000000, 12.000000)">
                            <g id="编组-43" transform="translate(0.000000, 0.000000)">
                                <rect id="矩形" x="2.06057393e-13" y="0" width="54" height="54"></rect>
                                <g id="编组-40" transform="translate(7.000000, 7.500000)">
                                    <g id="编组-39" transform="translate(5.326389, 5.333333)" stroke-width="2">
                                        <g id="编组-38" transform="translate(12.311111, 24.000000)" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="0.444444444" y1="0" x2="0.444444444" y2="8" id="路径-4" stroke="url(#linearGradient-1)"></line>
                                            <line x1="9.33333333" y1="0" x2="9.33333333" y2="8" id="路径-4" stroke="url(#linearGradient-2)"></line>
                                        </g>
                                        <rect id="矩形" stroke="url(#linearGradient-4)" fill="url(#linearGradient-3)" x="3.62376795e-13" y="0" width="34.4" height="24" rx="1"></rect>
                                        <path d="M28.0119575,5.76171875 C26.4629123,6.43373843 25.4053313,8.0192419 24.8392144,10.5182292 C24.2730975,13.0172164 23.1921513,13.385706 21.5963759,11.6236979 C19.6788411,10.0163484 18.2657914,10.4877749 17.3572266,13.0379774 C15.9943793,16.8632813 14.6037543,17.0870226 12.0162977,14.6113281 C9.42884115,12.1356337 6.38804253,15.9639757 6.38804253,18.2382812" id="路径-3" stroke="url(#linearGradient-5)" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <line x1="4.75555556" y1="32" x2="29.2" y2="32" id="路径-5" stroke="url(#linearGradient-6)" stroke-linecap="round" stroke-linejoin="round"></line>
                                    </g>
                                    <polyline id="路径-7" stroke="url(#linearGradient-7)" stroke-linecap="round" stroke-linejoin="round" points="0 18.3809609 0 1.33333333 30.8888889 1.33333333"></polyline>
                                    <circle id="椭圆形" stroke="url(#linearGradient-8)" cx="33.7708333" cy="0.888888889" r="1"></circle>
                                    <polyline id="路径-8" stroke="url(#linearGradient-9)" stroke-linecap="round" stroke-linejoin="round" points="9.19305556 9.85714712 9.19305556 25.365096 33.7708333 25.365096"></polyline>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    }
}

function change(limit) {
    var size = "";
    if (limit < 0.1 * 1024) {                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
    } else if (limit < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "K"
    } else if (limit < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "M"
    } else {                                            //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "G"
    }

    var sizeStr = size + "";                        //转成字符串
    var index = sizeStr.indexOf(".");                    //获取小数点处的索引
    var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
    if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
    }
    return size;
}

export function dateFormat(time, format = "yyyy-MM-dd HH:mm:ss") {
    let initTime = "1970-01-01T08:00:00+08:00";

    if (!time || time == initTime || time == "0001-01-01T00:00:00Z") {
        return "";
    }
    if (typeof time == "string") {
        time = new Date(time);
    }

    if (typeof time == "object") {
        if (time.seconds) {
            let d = new Date(initTime);

            d.setSeconds(time.seconds);
            time = d;
        }
    }

    var t = time;
    var tf = function (i) {
        return (i < 10 ? "0" : "") + i;
    };

    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
            case "yyyy":
                return tf(t.getFullYear());
            case "MM":
                return tf(t.getMonth() + 1);
            case "mm":
                return tf(t.getMinutes());
            case "dd":
                return tf(t.getDate());
            case "HH":
                return tf(t.getHours());
            case "ss":
                return tf(t.getSeconds());
        }
    });
}